import React, { Component } from 'react';
import { Col } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import Amplify from 'aws-amplify';
import { withAuthenticator } from 'aws-amplify-react';

// aws cognito configuration
import awsExports from '../../../../aws_exports';

Amplify.configure(awsExports);

class Login extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <Col>
        <Redirect to="/reports" />
      </Col>
    );
  }
}
export default withAuthenticator(Login, true);



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js